export default __webpack_public_path__ + "static/media/maestro.523899e2.png";